import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

class IconComponent {
    icon;
    size = '';
    solid = true;
    class = '';
    constructor() { }
    ngOnInit() {
        if (this.icon.includes('fa-solid'))
            this.icon = this.icon.replace('fa-solid', '').trim();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: IconComponent, isStandalone: true, selector: "a-icon[icon]", inputs: { icon: "icon", size: "size", solid: "solid", class: "class" }, ngImport: i0, template: `
		<i
			class="{{ solid ? 'fa-solid' : 'fa-regular' }} {{ icon.startsWith('fa-') ? icon : 'fa-' + icon }} {{
				size
			}} {{ class }}"></i>
	`, isInline: true, dependencies: [{ kind: "ngmodule", type: CommonModule }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IconComponent, decorators: [{
            type: Component,
            args: [{ selector: 'a-icon[icon]', standalone: true, imports: [CommonModule], template: `
		<i
			class="{{ solid ? 'fa-solid' : 'fa-regular' }} {{ icon.startsWith('fa-') ? icon : 'fa-' + icon }} {{
				size
			}} {{ class }}"></i>
	`, changeDetection: ChangeDetectionStrategy.OnPush }]
        }], ctorParameters: function () { return []; }, propDecorators: { icon: [{
                type: Input
            }], size: [{
                type: Input
            }], solid: [{
                type: Input
            }], class: [{
                type: Input
            }] } });

/**
 * Generated bundle index. Do not edit.
 */

export { IconComponent };
